import * as React from 'react';
import { Box, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { parseISO } from 'date-fns';

interface Props {
  label: string;
  onChange: Function;
  value?: string;
  dateProps?: {
    minDate?: Date;
    maxDate?: Date;
  };
}

export function ResponsiveDatePicker(props: Props) {
  const [error, setError] = React.useState<string | null>(null);

  const { label, value, onChange, dateProps } = props;
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ width: '100%' }}>
        <DatePicker
          onError={e => setError(e)}
          format="dd/MM/yyyy"
          label={label}
          value={value ? parseISO(value) : null}
          onChange={(newValue, selectionState) => {
            console.log(newValue);
            onChange(newValue ? newValue.toISOString() : null); // Convert Date to ISO string
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
